/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tab_Document_AnalysisInputs */

const en_project_tab_document_analysis = /** @type {(inputs: Project_Tab_Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document Analysis`)
};

const nl_project_tab_document_analysis = /** @type {(inputs: Project_Tab_Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document Analyse`)
};

/**
* | output |
* | --- |
* | "Document Analysis" |
*
* @param {Project_Tab_Document_AnalysisInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_tab_document_analysis = /** @type {((inputs?: Project_Tab_Document_AnalysisInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tab_Document_AnalysisInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_project_tab_document_analysis(inputs)
	return en_project_tab_document_analysis(inputs)
});